import React from "react";
import {
  FormErrorMessage,
  useDisclosure,
  Flex,
  Button,
  Text,
  Select,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Input,
  Textarea,
  Stack,
  HStack,
  VStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  RadioGroup,
  Radio,
  Box,
  SelectField
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import NavBar from "../widgets/NavBar";
import ProgressBar from "@ramonak/react-progress-bar";
import { database, auth } from "../../firebase";

export default function Postjob() {
  const [modal2Data, setModal2Data] = React.useState(false);
  const [newTextArea, setNewTextArea] = React.useState([]);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const taskSteps1 = React.useRef({});
  const requiredProofs1 = React.useRef({});
  const selected1 = React.useRef("international");
  const radioSelected1 = React.useRef("");
  const jobTitleValue1 = React.useRef("");
  const additionalNotesValue1 = React.useRef("");
  const workersNeedValue1 = React.useRef("");
  const workersEarnedValue1 = React.useRef("");
  const timeToRate1 = React.useRef("");

  // const [render, setRender] = React.useState("None");

  const [buttonLoading, setButtonLoading] = React.useState(false);

  function fun(value, index) {
    return (
      <Textarea
        mb="4"
        placeholder={`Step ${index + 4}`}
        width="350px"
        onChange={(e) => {
          let val = e.target.value;
          // taskSteps[`Step${index + 4}`] = val;
          // setTaskSteps({ ...taskSteps });
          taskSteps1.current[`Step${index + 4}`] = val;
        }}
      />
    );
  }

  return (
    <Flex>
      <NavBar />
      <Flex marginTop="10" flexDirection="column" width="100%" mb="10">
        <VStack spacing="24px" mt="10">
          <Flex flexDirection="column" alignItems="center">
            <FormControl>
              <Flex flexDirection="column" alignItems="left" width="100%">
                <FormLabel htmlFor="first-name">
                  Choose Targeting Region
                </FormLabel>
              </Flex>

              <Select
                width="80"
                placeholder="International"
                onChange={(e) => {
                  // setSelected(e.target.value);
                  selected1.current = e.target.value;
                }}>
                <option value="Asia">Asia</option>
                <option value="Africa">Africa</option>
                <option value="Europe">Europe</option>
                <option value="North America">North America</option>
                <option value="South America">South America</option>
                <option value="Oceania">Oceania</option>
              </Select>
            </FormControl>
          </Flex>

          <Flex flexDirection="column" alignItems="center">
            <FormControl isRequired>
              <Flex flexDirection="column" alignItems="left" width="100%">
                <FormLabel htmlFor="first-name">Choose Category</FormLabel>
              </Flex>

              <Button
                width="80"
                rightIcon={<ChevronDownIcon />}
                onClick={onOpen}
                ref={btnRef}>
                Select Category
              </Button>
            </FormControl>
          </Flex>

          <Flex flexDirection="column" alignItems="center">
            <FormControl isRequired>
              <Flex flexDirection="column" alignItems="left" width="100%">
                <FormLabel htmlFor="first-name">Choose Sub-Category</FormLabel>
              </Flex>
              <Button
                width="80"
                rightIcon={<ChevronDownIcon />}
                // onClick={onOpen}
                // ref={btnRef}
              >
                Select Sub-Category
              </Button>
            </FormControl>
          </Flex>

          <Flex flexDirection="column" alignItems="left">
            <FormControl isRequired>
              <FormLabel htmlFor="first-name">Job Title</FormLabel>
              <Input
                id="first-name"
                placeholder="Job Title"
                w="320px"
                onChange={(e) => {
                  // setJobTitleValue(e.target.value);
                  jobTitleValue1.current = e.target.value;
                }}
              />
            </FormControl>
          </Flex>

          <Flex flexDirection="column" alignItems="left">
            <FormControl isRequired>
              <FormLabel htmlFor="first-name">
                Tasks need to be completed
              </FormLabel>
            </FormControl>
            <Textarea
              mb="4"
              placeholder="Step 1"
              width="350px"
              onChange={(e) => {
                let val = e.target.value;
                // taskSteps["Step1"] = val;
                // setTaskSteps({ ...taskSteps });
                taskSteps1.current["Step1"] = val;
              }}
            />
            <Textarea
              mb="4"
              placeholder="Step 2"
              width="350px"
              onChange={(e) => {
                let val = e.target.value;
                // taskSteps["Step2"] = val;
                // setTaskSteps({ ...taskSteps });
                taskSteps1.current["Step2"] = val;
              }}
            />
            <Textarea mb="4" placeholder="Step 3" width="350px" />
            {newTextArea.map(fun)}
            <Flex justifyContent="space-between" w="350px">
              <Button
                w="170px"
                colorScheme="blue"
                onClick={() => {
                  // arr.push("new");
                  setNewTextArea((arr) => [...arr, "New"]);
                }}>
                Add Step
              </Button>
              <Button
                w="170px"
                colorScheme="red"
                onClick={() => {
                  // arr.push("new");
                  let length = newTextArea.length + 3;
                  newTextArea.pop();
                  setNewTextArea((arr) => [...arr]);
                  // delete taskSteps[`Step${length}`];
                  // setTaskSteps({ ...taskSteps });
                  delete taskSteps1.current[`Step${length}`];
                }}>
                Remove Step
              </Button>
            </Flex>
          </Flex>

          <Flex flexDirection="column" alignItems="left">
            <FormLabel htmlFor="first-name">Additional Notes</FormLabel>
            <Textarea
              placeholder="Add notes or comments."
              width="350px"
              onChange={(e) => {
                // setAdditionalNotesValue(e.target.value);
                additionalNotesValue1.current = e.target.value;
              }}
            />
          </Flex>

          <Flex flexDirection="column" alignItems="left">
            <FormControl isRequired>
              <FormLabel htmlFor="amount">Workers needed</FormLabel>
              <NumberInput
                max={2000}
                min={10}
                onChange={(e) => {
                  // setWorkersNeedValue(e);
                  workersNeedValue1.current = e;
                }}>
                <NumberInputField
                  id="amount"
                  placeholder="Minimum 10 Workers"
                />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>
          </Flex>

          <Flex flexDirection="column" alignItems="left">
            <FormControl isRequired>
              <FormLabel htmlFor="amount">Workers will earned</FormLabel>
              <NumberInput
                max={2.5}
                onChange={(e) => {
                  // setWorkersEarnedValue(e);
                  workersEarnedValue1.current = e;
                }}>
                <NumberInputField
                  id="amount"
                  placeholder="Depends on Category"
                />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>
          </Flex>

          <Flex flexDirection="column" alignItems="left">
            <FormControl isRequired>
              <FormLabel htmlFor="amount">Time to rate</FormLabel>
              <NumberInput
                max={7}
                min={1}
                onChange={(e) => {
                  // setTimeToRate(e);
                  timeToRate1.current = e;
                  console.log(e);
                }}>
                <NumberInputField id="amount" placeholder="Max. 7 Days" />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>
          </Flex>

          <Flex flexDirection="column" alignItems="left">
            <FormControl isRequired>
              <FormLabel>Required proof that the job was completed</FormLabel>
            </FormControl>
            <Input
              id="first-name"
              placeholder="Proof 1"
              w="320px"
              mb="2"
              onChange={(e) => {
                let val = e.target.value;
                try {
                  // requiredProofs.proof1.proof1Details = val;
                  requiredProofs1.current.proof1.proof1Details = val;
                } catch (TypeError) {
                  // requiredProofs["proof1"] = {
                  //   type: "",
                  //   proof1Details: val
                  // };
                  requiredProofs1.current["proof1"] = {
                    type: "",
                    proof1Details: val
                  };
                }
                // setRequirdProofs({ ...requiredProofs });
              }}
            />
            <Select
              width="80"
              placeholder="Select Proof 1 Type"
              mb="4"
              onChange={(e) => {
                let val = e.target.value;
                try {
                  // requiredProofs.proof1.type = val;
                  requiredProofs1.current.proof1.type = val;
                } catch (TypeError) {
                  // requiredProofs["proof1"] = {
                  //   type: val,
                  //   proof1Details: ""
                  // };
                  requiredProofs1.current["proof1"] = {
                    type: val,
                    proof1Details: ""
                  };
                }
                // setRequirdProofs({ ...requiredProofs });
              }}>
              <option value="Text">Text Proof</option>
              <option value="Screenshot">Screenshot Proof</option>
            </Select>
            <Input
              id="first-name"
              placeholder="Proof 2"
              w="320px"
              mb="2"
              onChange={(e) => {
                let val = e.target.value;
                try {
                  // requiredProofs.proof2.proof2Details = val;
                  requiredProofs1.current.proof2.proof2Details = val;
                } catch (TypeError) {
                  // requiredProofs["proof2"] = {
                  //   type: "",
                  //   proof2Details: val
                  // };
                  requiredProofs1.current["proof2"] = {
                    type: "",
                    proof2Details: val
                  };
                }
                // setRequirdProofs({ ...requiredProofs });
              }}
            />
            <Select
              width="80"
              placeholder="Select Proof 2 Type"
              mb="4"
              onChange={(e) => {
                let val = e.target.value;
                try {
                  // requiredProofs.proof2.type = val;
                  requiredProofs1.current.proof2.type = val;
                } catch (TypeError) {
                  // requiredProofs["proof2"] = {
                  //   type: val,
                  //   proof2Details: ""
                  // };
                  requiredProofs1.current["proof2"] = {
                    type: val,
                    proof2Details: ""
                  };
                }
                // setRequirdProofs({ ...requiredProofs });
              }}>
              <option value="Text">Text Proof</option>
              <option value="Screenshot">Screenshot Proof</option>
            </Select>
            <Input id="first-name" placeholder="Proof 3" w="320px" mb="2" />
            <Select width="80" placeholder="Select Proof 3 Type" mb="4">
              <option value="Text">Text Proof</option>
              <option value="Screenshot">Screenshot Proof</option>
            </Select>
          </Flex>

          <Box
            width="320px"
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            padding="3">
            <Flex flexDirection="column" alignItems="center">
              <FormLabel>Estimated Job Costs</FormLabel>

              <Text fontWeight="bold" fontSize="21" textAlign="center">
                ${((45 * 0.05) / 100) * 5 + 0.5 + 45 * 0.05}
              </Text>
            </Flex>
          </Box>

          <Flex flexDirection="column" alignItems="left">
            {/* {timeToRate}
            {JSON.stringify(taskSteps)}
            {JSON.stringify(requiredProofs)} */}

            {/* {render} */}

            <Button
              isLoading={buttonLoading}
              colorScheme="blue"
              width="40"
              onClick={() => {
                // setRender(JSON.stringify(requiredProofs1.current));
                setButtonLoading(true);
                database
                  .collection("campaigns")
                  .add({
                    camapignTitle: jobTitleValue1.current,
                    campaign_additional_notes: additionalNotesValue1.current,
                    campaign_bid: workersEarnedValue1.current,
                    campaign_workers_need: workersNeedValue1.current,
                    campaign_task_to_rate: timeToRate1.current,
                    campaign_proofs: requiredProofs1.current,
                    campaign_steps: taskSteps1.current,
                    campaign_region: selected1.current,
                    campaign_category: radioSelected1.current
                  })
                  .then(() => {
                    setButtonLoading(false);
                  });
              }}>
              Submit
            </Button>
          </Flex>

          <Modal
            isOpen={isOpen}
            finalFocusRef={btnRef}
            onClose={onClose}
            id={1}
            scrollBehavior="inside">
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Category</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <RadioGroup
                  onChange={(e) => {
                    // setRadioSelected(e);
                    radioSelected1.current = e;
                  }}>
                  <Stack direction="column">
                    <Radio value="Facebook">Facebook</Radio>
                    <Radio value="Instagram">Instagram</Radio>
                    <Radio value="Twitter">Twitter</Radio>
                    <Radio value="Video Marketing">Video Marketing</Radio>
                    <Radio value="Sign Up">Sign Up</Radio>
                    <Radio value="Search, Click,(Engage)">
                      Search, Click,(Engage)
                    </Radio>
                    <Radio value="Promotion(Voting & Rating)">
                      Promotion(Voting & Rating)
                    </Radio>
                    <Radio value="Reddit">Reddit</Radio>
                    <Radio value="Yahoo Answers, Quora, etc.">
                      Yahoo Answers, Quora, etc.
                    </Radio>
                    <Radio value="Forums">Forums</Radio>
                    <Radio value="Computer Programs(PC)">
                      Computer Programs(PC)
                    </Radio>
                    <Radio value="Commment on other blogs">
                      Comment on other blogs
                    </Radio>
                    <Radio value="Write an honest review">
                      Write an honest review
                    </Radio>
                    <Radio value="Write an article">Write an article</Radio>
                    <Radio value="Mobile Applications">
                      Mobile Applications
                    </Radio>
                    <Radio value="Blog/Website Owners">
                      Blog/Website Owners
                    </Radio>
                    <Radio value="Leads">Leads</Radio>
                    <Radio value="Surveys/Offers">Surveys/Offers</Radio>
                    <Radio value="Other">Other</Radio>
                  </Stack>
                </RadioGroup>
              </ModalBody>

              <ModalFooter>
                <Button colorScheme="red" mr={3} onClick={onClose}>
                  Close
                </Button>
                <Button
                  colorScheme="blue"
                  onClick={() => {
                    onClose(true);
                  }}>
                  Apply
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </VStack>
      </Flex>
    </Flex>
  );
}
